import { Editor, Range } from 'slate';
import areSamePoints from '@atlas/tool/box/slate/areSamePoints';
import removeTopLevelBlocks from '@atlas/tool/box/slate/removeTopLevelBlocks';
import sortSelection from '@atlas/tool/box/slate/sortSelection';
import deleteBlockPart from '@atlas/tool/box/slate/deleteBlockPart';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function deleteSelection(editor: Editor, selection: Range) {
    // TODO: @Stan Compare active selection and update it after deleting

    const { anchor, focus } = selection;
    if (areSamePoints(anchor, focus)) return false;

    const [selectionStart, selectionEnd] = sortSelection(selection);

    const blockStartPoint = Editor.start(editor, [selectionStart.path[0]]);
    const blockEndPoint = Editor.end(editor, [selectionEnd.path[0]]);

    const isBlockStartSelected = areSamePoints(selectionStart, blockStartPoint);
    const isBlockEndSelected = areSamePoints(selectionEnd, blockEndPoint);

    if (isBlockStartSelected && isBlockEndSelected) {
        // blocks are completely selected

        removeTopLevelBlocks(editor, blockStartPoint.path[0], blockEndPoint.path[0], true);

        const focus =
            blockStartPoint.path[0] > editor.children.length
                ? blockStartPoint.path[0] === 0
                    ? Editor.start(editor, [0])
                    : Editor.end(editor, [blockStartPoint.path[0]])
                : blockStartPoint.path[0] === 0
                ? Editor.end(editor, [0])
                : Editor.end(editor, [blockStartPoint.path[0] - 1]);
        changeEditorSelection(editor, { anchor: focus, focus });

        return true;
    }

    if (selectionStart.path[0] === selectionEnd.path[0]) {
        // one block is partially selected

        deleteBlockPart(editor, selection);
    } else {
        if (!isBlockEndSelected) {
            // if last block is selected not to the end
            deleteBlockPart(editor, {
                anchor: Editor.start(editor, [selectionEnd.path[0]]),
                focus: selectionEnd,
            });
        }

        if (
            selectionStart.path[0] + (isBlockStartSelected ? 0 : 1) <=
            selectionEnd.path[0] - (isBlockEndSelected ? 0 : 1)
        ) {
            // Delete completely selected top-level blocks
            removeTopLevelBlocks(
                editor,
                selectionStart.path[0] + (isBlockStartSelected ? 0 : 1),
                selectionEnd.path[0] - (isBlockEndSelected ? 0 : 1),
                true,
            );
        }

        if (!isBlockStartSelected) {
            // if first block is selected not from the beginning
            deleteBlockPart(editor, {
                anchor: selectionStart,
                focus: Editor.end(editor, [selectionStart.path[0]]),
            });
        }
    }

    if (selectionStart.offset !== 0 || selectionStart.path[selectionStart.path.length - 1] !== 0) {
        changeEditorSelection(editor, {
            anchor: selectionStart,
            focus: selectionStart,
        });
    }

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('deleteSelection', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
